module.exports = __webpack_public_path__ + "img/cameramanager-logo.63d8b5de.png";